import type { CustomIconProps } from '../CustomIcon';

export const UsersIcon = ({
  color,
  secondaryColor,
  ternaryColor,
  solid,
  size = 24,
  ...props
}: CustomIconProps) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={size}
      height={size}
      fill={solid ? color : 'none'}
      stroke={solid ? color : secondaryColor}
      strokeWidth={1.5}
      strokeLinecap='round'
      strokeLinejoin='round'
      {...props}>
      <path d='M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2' />
      <circle cx={9} cy={7} r={4} />
      <path
        d='M23 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75'
        stroke={secondaryColor}
        fill='transparent'
      />
    </svg>
  );
};
